module.exports = __webpack_public_path__ + "img/next.353a065d.svg";